// manifest ภาพตัวละคร (คัดกรองแล้ว) — ไฟล์จริงอยู่ที่ public/characters/ (ไม่ถูก bundle)
//   char-XX.webp (เต็ม ≤1280px) · med/ (720px) · thumb/ (360px) · _excluded/ = ภาพที่ไม่ใช้ (ไม่ลบ)
// แถว: [id, เพศ(m/f), โทน(cute|cool|fantasy|romance|dark), สีเฉลี่ย, กว้าง, สูง]
const ROWS = [
  ["01","m","cool","#897f81",853,1280],
  ["02","m","cool","#4c5156",673,1200],
  ["03","m","cool","#505d69",928,1232],
  ["04","m","dark","#383939",720,1280],
  ["05","m","cool","#887672",879,1280],
  ["06","m","cool","#553934",720,1280],
  ["07","m","fantasy","#a69588",908,1200],
  ["08","m","cool","#65362e",1008,1280],
  ["09","m","cool","#614940",921,1200],
  ["10","m","cool","#5d524a",1024,1024],
  ["100","m","cool","#9c908a",928,1232],
  ["101","m","cool","#595149",960,1280],
  ["102","m","cool","#584a53",1024,1024],
  ["11","m","cool","#5b3f34",853,1280],
  ["111","m","dark","#23242a",853,1280],
  ["112","m","dark","#2e2d31",853,1280],
  ["113","m","dark","#372f29",658,1174],
  ["114","m","dark","#3a3636",808,1200],
  ["115","m","dark","#342f2f",853,1280],
  ["116","m","dark","#252627",853,1280],
  ["119","m","fantasy","#818083",736,977],
  ["12","m","cool","#828185",474,842],
  ["120","m","fantasy","#827167",928,1232],
  ["121","m","fantasy","#434144",928,1232],
  ["122","m","fantasy","#b5a08a",736,1116],
  ["123","m","dark","#443732",928,1232],
  ["124","m","fantasy","#8f6a52",928,1232],
  ["125","m","fantasy","#7c5b48",928,1232],
  ["126","m","cute","#9ba0a6",1024,1024],
  ["127","m","cute","#67707d",1024,1024],
  ["128","m","cute","#7d8187",1024,1024],
  ["129","m","cute","#7b7e82",1024,1024],
  ["13","m","dark","#332725",736,1104],
  ["130","m","cute","#82838f",1080,1053],
  ["131","m","cute","#646d81",1024,1024],
  ["133","m","dark","#302e2a",658,1128],
  ["134","m","cool","#635c57",928,1232],
  ["135","m","cool","#706260",960,1280],
  ["136","m","cool","#888380",1078,1261],
  ["137","m","cool","#7a5f56",904,1200],
  ["138","m","cool","#786458",720,956],
  ["139","m","dark","#312c2f",673,1200],
  ["14","m","fantasy","#9e937f",1024,1024],
  ["140","m","dark","#3a2a2e",673,1200],
  ["141","m","dark","#332023",673,1200],
  ["142","m","dark","#2b272b",673,1200],
  ["143","m","dark","#2e2323",673,1200],
  ["144","m","dark","#472727",673,1200],
  ["145","m","dark","#232025",673,1200],
  ["146","m","dark","#32292b",673,1200],
  ["147","m","dark","#242022",673,1200],
  ["148","m","dark","#1c1b1f",928,1232],
  ["149","m","cool","#807a77",928,1232],
  ["15","m","fantasy","#997d69",1024,1024],
  ["150","m","cool","#4b4e53",904,1200],
  ["151","m","cool","#5d5a5c",564,814],
  ["152","m","dark","#423f3c",564,839],
  ["153","m","cool","#635751",717,1280],
  ["154","m","cool","#47423b",717,1280],
  ["155","m","dark","#3c3534",904,1200],
  ["157","m","cool","#4e3e31",717,1280],
  ["158","m","cool","#574b3f",717,1280],
  ["159","m","dark","#433836",717,1280],
  ["16","m","fantasy","#978776",1024,1024],
  ["160","m","dark","#3a3633",717,1280],
  ["161","m","dark","#2e2c2c",717,1280],
  ["162","m","dark","#473d36",717,1280],
  ["163","m","dark","#3a362e",717,1280],
  ["164","m","cool","#584b41",717,1280],
  ["165","m","dark","#3b322b",717,1280],
  ["166","m","cool","#5f5754",717,1280],
  ["167","m","cool","#60554d",717,1280],
  ["168","m","cool","#696768",960,1280],
  ["169","m","cool","#504746",928,1232],
  ["17","m","cool","#6b4a38",1024,1024],
  ["170","m","cool","#4f4441",1024,1024],
  ["171","m","dark","#403a3b",720,956],
  ["173","m","fantasy","#918988",727,1280],
  ["174","m","fantasy","#55473e",964,1280],
  ["175","m","fantasy","#727275",658,1190],
  ["176","m","fantasy","#a69d9c",960,1280],
  ["177","m","fantasy","#828083",658,1172],
  ["178","m","fantasy","#9c928d",727,1280],
  ["179","m","fantasy","#8a868d",1024,1024],
  ["18","m","cool","#5c505e",736,736],
  ["180","m","fantasy","#818187",1024,1024],
  ["181","m","fantasy","#615b55",658,877],
  ["182","m","fantasy","#89736e",928,1232],
  ["183","m","fantasy","#8a7c7a",928,1232],
  ["184","m","fantasy","#524b46",720,960],
  ["185","m","dark","#433b3a",720,960],
  ["186","m","fantasy","#877a78",802,1032],
  ["187","m","fantasy","#5d4e43",450,676],
  ["188","m","fantasy","#41444f",964,1280],
  ["189","m","fantasy","#5b626c",964,1280],
  ["19","m","cool","#655e57",1024,1024],
  ["190","m","fantasy","#837c7a",717,1280],
  ["191","m","fantasy","#876f60",717,1280],
  ["192","m","fantasy","#65575f",717,1280],
  ["193","m","fantasy","#695d5a",717,1280],
  ["194","m","fantasy","#504f4d",717,1280],
  ["195","m","fantasy","#5d696d",964,1280],
  ["196","m","fantasy","#494f5a",964,1280],
  ["197","f","romance","#433c3b",720,1280],
  ["198","f","cute","#927e7c",853,1280],
  ["199","f","romance","#5e5657",504,1008],
  ["20","m","cool","#665857",1024,1024],
  ["200","f","cute","#a5978e",960,1280],
  ["201","f","romance","#534a47",664,1136],
  ["202","f","cute","#ae8e7a",721,1280],
  ["203","f","romance","#70685d",853,1280],
  ["204","f","romance","#644e47",640,1280],
  ["206","f","romance","#5a5048",960,1280],
  ["208","f","cute","#9e9c9f",768,1152],
  ["209","f","romance","#5e5959",720,1280],
  ["21","m","cool","#a68f77",736,736],
  ["210","f","romance","#877575",768,1152],
  ["212","f","romance","#5f4f48",736,1090],
  ["213","f","dark","#332b27",725,1280],
  ["215","f","cute","#898383",768,1280],
  ["216","f","romance","#747365",853,1280],
  ["217","f","cute","#948786",760,1280],
  ["218","f","romance","#7a7774",720,1280],
  ["22","m","cool","#55544e",1024,1024],
  ["220","f","cute","#8f8680",768,1152],
  ["221","f","cute","#9a897c",768,1152],
  ["222","f","cute","#9b979d",720,1058],
  ["224","f","cute","#868387",768,1152],
  ["225","f","dark","#38343a",889,1280],
  ["226","f","romance","#564f52",736,1150],
  ["228","f","cute","#948680",768,1152],
  ["229","f","cute","#b3b4b6",640,960],
  ["23","m","cool","#5f4338",1024,1024],
  ["230","f","romance","#65605e",450,675],
  ["231","f","cute","#b49f97",853,1280],
  ["232","f","romance","#3f5364",576,1024],
  ["233","f","cute","#b08b8d",576,1024],
  ["236","f","cute","#c8b5b1",675,1200],
  ["237","f","cute","#bd9585",673,1200],
  ["238","f","romance","#6f646a",720,1279],
  ["239","f","romance","#7b6e60",720,1280],
  ["24","m","dark","#3e3938",1024,1024],
  ["240","f","cute","#8c8381",960,1280],
  ["241","f","cute","#8f8281",768,1152],
  ["242","f","cute","#8f867e",768,1152],
  ["243","f","romance","#5f5651",720,1054],
  ["244","f","cute","#a69fbe",664,1280],
  ["245","f","cute","#94837c",853,1280],
  ["246","f","romance","#725c5d",654,1162],
  ["247","f","romance","#71635f",512,768],
  ["248","f","romance","#7b7470",768,1152],
  ["249","f","romance","#867868",928,1232],
  ["25","m","cool","#6b4f3c",1280,1280],
  ["250","f","romance","#6d6f90",768,1280],
  ["251","f","romance","#847972",768,1152],
  ["252","f","romance","#68605a",768,1152],
  ["256","f","romance","#5e6682",768,1280],
  ["257","f","romance","#87776a",853,1280],
  ["258","f","romance","#7a736e",768,1152],
  ["259","f","romance","#404040",900,900],
  ["26","m","cool","#674d3e",1200,1200],
  ["261","f","cute","#afa6a4",736,1226],
  ["262","f","cute","#aa9d99",768,1152],
  ["263","f","romance","#857262",688,1024],
  ["265","f","cute","#988a80",768,1152],
  ["266","f","romance","#645448",768,1152],
  ["267","f","cute","#8e7d71",768,1152],
  ["268","f","cute","#8b93ab",720,1280],
  ["269","f","cute","#a89a98",768,1152],
  ["27","m","cool","#6f7886",1024,1024],
  ["270","f","cute","#a9968a",768,1152],
  ["271","f","romance","#5e5d5a",640,640],
  ["272","f","cute","#8b827d",768,1152],
  ["273","f","cute","#968473",768,1152],
  ["274","f","romance","#645a4e",768,1280],
  ["275","f","cute","#9e8f8a",768,1024],
  ["276","f","romance","#665a55",1024,1024],
  ["277","f","romance","#5b4e4b",928,928],
  ["278","f","cute","#a79993",746,1280],
  ["279","f","romance","#706b6a",727,1280],
  ["28","m","cool","#5b4231",736,736],
  ["280","f","romance","#8d7781",768,1280],
  ["281","f","romance","#736d69",768,1152],
  ["282","f","romance","#726d76",722,1280],
  ["283","f","romance","#514f4e",768,1152],
  ["284","f","cute","#e7e2df",720,1280],
  ["285","f","cute","#877e7f",768,1152],
  ["286","f","romance","#5e524b",768,1152],
  ["287","f","cute","#898582",853,1280],
  ["289","f","cute","#ad7d88",736,1226],
  ["29","m","cool","#7c6c63",678,1210],
  ["290","m","cool","#625c59",853,1280],
  ["291","f","cute","#818081",819,1280],
  ["292","f","romance","#60504d",768,1152],
  ["293","f","romance","#4d5055",512,768],
  ["294","f","cute","#8f867f",768,1152],
  ["295","f","romance","#905541",853,1280],
  ["296","f","cute","#8e837c",768,1152],
  ["297","f","romance","#867068",768,1152],
  ["298","f","cute","#a48c81",720,1280],
  ["299","f","romance","#7e7879",768,1152],
  ["30","m","cool","#444038",736,1104],
  ["300","f","romance","#786f6d",768,1280],
  ["301","f","cute","#978f8d",736,981],
  ["302","f","cute","#beaca5",768,1152],
  ["304","f","cute","#98948f",768,1152],
  ["305","f","romance","#816e63",736,1104],
  ["306","f","cute","#8a7f80",768,1152],
  ["307","f","romance","#665956",768,1152],
  ["309","f","romance","#624f4e",720,1280],
  ["31","m","cool","#4e4643",720,1280],
  ["310","f","romance","#5d5147",768,1152],
  ["311","f","romance","#544f52",960,1280],
  ["312","f","fantasy","#9d8981",664,1184],
  ["313","f","fantasy","#938a87",853,1280],
  ["314","f","fantasy","#605b58",605,687],
  ["315","f","fantasy","#9a9091",768,1152],
  ["316","f","fantasy","#887f7e",1076,1060],
  ["317","f","fantasy","#8a6548",720,1280],
  ["318","f","fantasy","#77696a",768,1152],
  ["319","f","fantasy","#93877c",960,1280],
  ["32","m","cool","#4d4d50",720,1048],
  ["320","f","fantasy","#646e75",959,1280],
  ["321","f","fantasy","#818375",1024,1024],
  ["322","f","fantasy","#7e7476",768,1152],
  ["323","f","fantasy","#7b7167",768,1152],
  ["324","f","fantasy","#8a8079",768,1152],
  ["325","f","fantasy","#c1c6cb",733,1280],
  ["326","f","fantasy","#8c8483",768,1152],
  ["327","f","fantasy","#4d4438",600,900],
  ["328","f","fantasy","#6c5e57",853,1280],
  ["33","m","fantasy","#6c5d55",664,1176],
  ["330","f","fantasy","#a09695",964,1280],
  ["332","f","fantasy","#979091",959,1280],
  ["333","f","fantasy","#baaa9f",768,1152],
  ["334","f","fantasy","#6f6667",720,1280],
  ["336","f","fantasy","#635b59",768,1152],
  ["338","f","fantasy","#8f857e",768,1152],
  ["339","f","fantasy","#5a514d",768,1152],
  ["34","m","fantasy","#7f7f62",853,1280],
  ["340","f","fantasy","#8a8073",768,1152],
  ["341","f","fantasy","#6a594c",720,720],
  ["342","f","fantasy","#beaea7",768,1152],
  ["343","f","fantasy","#979089",960,1280],
  ["344","f","fantasy","#938d8b",853,1280],
  ["345","f","fantasy","#b69e96",707,1280],
  ["346","f","fantasy","#7d7270",889,1280],
  ["347","f","fantasy","#b7a8a1",768,1152],
  ["348","f","fantasy","#a68881",768,1152],
  ["349","f","fantasy","#968c8d",1076,1052],
  ["35","m","fantasy","#6780b2",1024,1280],
  ["350","f","fantasy","#9d948e",768,1152],
  ["351","f","fantasy","#8c898b",960,1280],
  ["352","f","fantasy","#999088",768,1152],
  ["353","f","fantasy","#a0958c",853,1280],
  ["354","f","dark","#2e3349",741,1280],
  ["355","f","fantasy","#9d958f",768,1152],
  ["356","f","fantasy","#848282",768,1152],
  ["357","f","fantasy","#a49ea0",720,1280],
  ["358","f","fantasy","#7e7265",768,1280],
  ["359","f","fantasy","#7e7167",768,1152],
  ["36","m","fantasy","#6d7a61",717,1280],
  ["360","f","fantasy","#a79089",720,1280],
  ["361","f","fantasy","#8f8572",960,1280],
  ["362","f","fantasy","#8c7663",721,1280],
  ["363","f","fantasy","#5e5b5f",794,1280],
  ["364","f","fantasy","#62696f",768,1152],
  ["365","f","fantasy","#a09288",768,1152],
  ["366","f","fantasy","#b9aaa2",768,1152],
  ["367","f","fantasy","#59413c",768,1152],
  ["368","f","fantasy","#91867b",720,1280],
  ["369","f","fantasy","#8b7f76",768,1152],
  ["37","m","cool","#708395",736,919],
  ["370","f","fantasy","#75756e",768,1152],
  ["371","f","fantasy","#8f857f",768,1152],
  ["372","f","fantasy","#917f78",736,1104],
  ["373","f","fantasy","#879bb8",720,1280],
  ["374","f","fantasy","#705854",1024,1280],
  ["375","f","fantasy","#57594f",720,1280],
  ["376","f","fantasy","#615955",960,1280],
  ["377","f","fantasy","#57453b",721,1280],
  ["379","f","fantasy","#484750",720,1280],
  ["38","m","cool","#50484d",959,1280],
  ["380","f","fantasy","#7d839e",720,1280],
  ["381","f","fantasy","#966c59",753,1280],
  ["382","f","fantasy","#5c5354",684,1280],
  ["383","f","fantasy","#717988",720,1215],
  ["384","f","fantasy","#885b44",720,1280],
  ["385","f","fantasy","#727477",723,1280],
  ["386","f","fantasy","#605953",720,1280],
  ["387","f","fantasy","#926c59",771,1280],
  ["388","f","fantasy","#847c71",512,768],
  ["389","f","fantasy","#8b837e",731,1280],
  ["39","m","cool","#444540",1024,1024],
  ["390","f","fantasy","#633522",853,1280],
  ["391","f","fantasy","#a79792",576,1024],
  ["392","f","fantasy","#7a8383",704,1280],
  ["393","f","fantasy","#887793",853,1280],
  ["394","f","fantasy","#735437",725,1280],
  ["395","f","dark","#341315",749,1280],
  ["40","m","cool","#5e5755",1280,1280],
  ["400","f","fantasy","#585a5e",681,1280],
  ["401","f","fantasy","#4f4539",720,1280],
  ["402","f","dark","#403541",960,1280],
  ["403","f","fantasy","#6a6969",704,1280],
  ["405","f","fantasy","#716f68",736,1105],
  ["406","f","fantasy","#7c8a84",717,1280],
  ["407","f","fantasy","#6b6159",768,1152],
  ["408","f","fantasy","#754336",768,1152],
  ["41","m","cool","#4c423d",928,1232],
  ["410","f","fantasy","#9c999a",720,1280],
  ["411","f","fantasy","#837f6d",720,1280],
  ["412","f","fantasy","#53535e",960,1280],
  ["413","f","fantasy","#978079",736,1226],
  ["414","f","fantasy","#504a48",684,1280],
  ["415","f","fantasy","#5d6756",717,1280],
  ["416","f","fantasy","#7c5f60",960,1280],
  ["417","f","fantasy","#6a635f",853,1280],
  ["418","f","fantasy","#7d5e54",853,1280],
  ["419","f","fantasy","#484457",768,1152],
  ["42","m","cool","#56565c",720,956],
  ["420","f","fantasy","#966d63",720,1280],
  ["421","f","fantasy","#9596a3",960,1280],
  ["422","f","fantasy","#796c62",960,1280],
  ["423","f","fantasy","#8c7e89",720,1280],
  ["424","f","fantasy","#9799a7",720,1280],
  ["426","f","fantasy","#8e7167",771,1280],
  ["429","f","fantasy","#949499",576,1024],
  ["43","m","cool","#454d5f",658,866],
  ["430","f","fantasy","#45434a",960,1280],
  ["431","f","fantasy","#794f48",720,1280],
  ["432","f","fantasy","#977f6d",960,1280],
  ["433","f","fantasy","#897382",711,1280],
  ["434","f","fantasy","#957d79",661,1200],
  ["435","f","fantasy","#806f63",960,1280],
  ["437","f","fantasy","#70583a",720,1280],
  ["438","f","fantasy","#7d5a3f",736,942],
  ["439","f","fantasy","#846e67",720,1280],
  ["44","m","cool","#72665b",853,1280],
  ["441","f","fantasy","#7e7a7c",960,1280],
  ["442","f","fantasy","#897b6d",768,1152],
  ["443","f","fantasy","#6e8095",724,1280],
  ["444","f","fantasy","#c7bdbc",960,1280],
  ["445","f","fantasy","#5f626a",720,1280],
  ["447","f","fantasy","#5a4038",1026,1280],
  ["448","f","fantasy","#a0978a",720,1280],
  ["449","f","fantasy","#9b6f64",723,1280],
  ["45","m","cool","#6c6c72",720,1280],
  ["450","f","fantasy","#b4a8a9",720,960],
  ["451","f","fantasy","#ae8382",541,928],
  ["452","f","fantasy","#846d71",720,1280],
  ["453","f","fantasy","#8f909c",576,977],
  ["454","f","fantasy","#a67c74",768,1152],
  ["455","f","fantasy","#a68c7c",720,1280],
  ["456","f","fantasy","#a69c8b",720,1280],
  ["458","f","fantasy","#868763",720,1280],
  ["459","f","fantasy","#613527",720,1280],
  ["46","m","cool","#5a626d",947,1280],
  ["460","f","fantasy","#726c6d",768,1152],
  ["461","f","fantasy","#716169",720,1280],
  ["462","f","fantasy","#908288",707,1280],
  ["463","f","fantasy","#bbb9bb",1024,1024],
  ["464","f","fantasy","#999492",661,1200],
  ["47","m","cool","#504b4c",720,1280],
  ["48","m","cool","#535050",928,1232],
  ["49","m","cool","#af967c",793,1280],
  ["50","m","dark","#2e2224",658,874],
  ["51","m","cool","#635b56",896,1194],
  ["52","m","cool","#4f463f",720,1280],
  ["53","m","cool","#866959",816,1088],
  ["54","m","cool","#55504e",928,1232],
  ["55","m","cool","#7f7c80",658,874],
  ["56","m","dark","#3d3e3f",853,1280],
  ["57","m","cool","#595752",853,1280],
  ["58","m","cool","#564b40",850,1280],
  ["59","m","cool","#685e53",928,1232],
  ["60","m","dark","#2d2c2e",720,1280],
  ["61","m","cool","#5a5751",960,1200],
  ["62","m","cool","#816c5c",853,1280],
  ["63","m","dark","#453e3a",853,1280],
  ["64","m","dark","#2d3239",853,1280],
  ["65","m","cool","#a08d7b",928,1232],
  ["66","m","dark","#332d28",644,854],
  ["67","m","cool","#544840",960,1200],
  ["68","m","cool","#654d3e",736,977],
  ["69","m","cool","#74534c",720,961],
  ["70","m","dark","#39302e",736,977],
  ["71","m","cool","#635148",958,1198],
  ["72","m","cool","#706c6c",1024,1280],
  ["73","m","cool","#795a4e",736,977],
  ["74","m","cool","#55433d",720,1229],
  ["75","m","cool","#6a4c3a",736,1104],
  ["76","m","dark","#453732",928,1232],
  ["77","m","cool","#523d31",1024,1024],
  ["78","m","dark","#332727",878,1200],
  ["79","m","cool","#786656",736,1104],
  ["80","m","cool","#604f45",736,977],
  ["81","m","cool","#4f443d",658,1132],
  ["82","m","cool","#717071",658,1170],
  ["83","m","dark","#433e3c",746,1280],
  ["84","m","cool","#ad7a5c",928,1232],
  ["85","m","cool","#493c3d",753,1280],
  ["86","m","cool","#775f55",719,1280],
  ["87","m","cool","#483e3c",743,1280],
  ["88","m","dark","#34364b",804,1280],
  ["89","m","cool","#4d4d50",720,1048],
  ["90","m","cool","#4c4d53",928,1232],
  ["91","m","dark","#353c51",804,1280],
  ["92","m","cool","#6a6360",683,1200],
  ["93","m","cool","#4c4d55",720,956],
  ["94","m","dark","#3f3532",923,1231],
  ["95","m","cool","#514c4e",658,874],
  ["96","m","dark","#3b332f",928,1232],
  ["97","m","cool","#816a5d",928,1232],
  ["98","m","cool","#534f51",720,956],
  ["99","m","cool","#4f453d",928,1232],
];

const base = () => `${process.env.PUBLIC_URL || ""}/characters`;

export const CHARACTER_IMAGES = ROWS.map(([id, g, tone, color, w, h]) => ({
  id, gender: g, tone, color, w, h, ratio: w / h,
  get file() { return `${base()}/char-${id}.webp`; },
  get med() { return `${base()}/med/char-${id}.webp`; },
  get thumb() { return `${base()}/thumb/char-${id}.webp`; },
}));

const BY_ID = new Map(CHARACTER_IMAGES.map((x) => [x.id, x]));
export const imageById = (id) => BY_ID.get(String(id)) || null;

export function hashStr(s) {
  let h = 2166136261;
  const str = String(s ?? "");
  for (let i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
  return h >>> 0;
}

/** ภาพ fallback จาก hash(seed) — seed เดิม = ภาพเดิมเสมอ ; opts.tone / opts.gender กรองได้ */
export function imageFor(seed, opts = {}) {
  let pool = CHARACTER_IMAGES;
  if (opts.tone) pool = pool.filter((x) => x.tone === opts.tone);
  if (opts.gender) pool = pool.filter((x) => x.gender === opts.gender);
  if (!pool.length) pool = CHARACTER_IMAGES;
  return pool[hashStr(seed) % pool.length];
}

/** ภาพชุดเด่น (หน้า landing/แบนเนอร์) — เลือกด้วยมือจากภาพสวย ๆ ในแต่ละโทน */
export const SHOWCASE_IDS = ["07", "124", "14", "123", "37", "394", "432", "384", "435", "393", "423", "412", "416", "373", "63", "62", "68", "45", "186", "402"];
export const showcase = () => SHOWCASE_IDS.map(imageById).filter(Boolean);

/** แปลง URL ภาพในโฟลเดอร์ characters เป็นขนาดที่ต้องการ ("thumb" 360px | "med" 720px | "full") ; URL อื่น (รูปจริงจาก GS) คืนค่าเดิม */
export const sizedSrc = (url, size = "thumb") => {
  const u = String(url || "");
  if (size === "full" || !/\/characters\/char-\d+\.webp$/.test(u)) return u;
  return u.replace(/\/characters\/(char-\d+\.webp)$/, `/characters/${size}/$1`);
};

/** ภาพของตัวละคร: รูปจริง (ถ้ามี) ไม่งั้น fallback จากภาพใน manifest ตาม hash(id) */
export const characterPic = (c, size = "thumb") => {
  const src = c?.image || imageFor(c?.id || c?.characterId || c?.name).file;
  return sizedSrc(src, size);
};
